'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventHandler = require('../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

var _themeImages = require('@shopify/theme-images');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function preloadImage(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      resolve(img);
    };
    img.onerror = function () {
      reject(img);
    };
    img.src = url;
  });
}

var DynamicFeatureBlocks = function () {
  function DynamicFeatureBlocks(section) {
    var _this = this;

    (0, _classCallCheck3.default)(this, DynamicFeatureBlocks);

    this.el = section.el;
    this.data = section.data;

    this.events = new _EventHandler2.default();

    this.showNextImage = this.showNextImage.bind(this);
    this.resetToFirstImage = this.resetToFirstImage.bind(this);

    this.data.blocks.forEach(function (block) {
      if (block.images.length > 1) {
        block.blockEl = _this.el.querySelector('[data-block-id="' + block.id + '"]');
        _this.events.register(block.blockEl, 'rimg:load', function () {
          block.imageSize = (0, _themeImages.imageSize)(block.blockEl.querySelector('[data-rimg]').currentSrc);
        });
        _this.events.register(block.blockEl, 'rimg:update', function () {
          block.imageSize = (0, _themeImages.imageSize)(block.blockEl.querySelector('[data-rimg]').currentSrc);
        });
        _this.events.register(block.blockEl, 'mouseenter', function () {
          if (block.imageSize) {
            block.flag = true;
            preloadImage(Shopify.getSizedImageUrl(block.images[1], block.imageSize)).then(function () {
              return _this.showNextImage(block);
            });
          }
        });
        _this.events.register(block.blockEl, 'mouseleave', function () {
          block.flag = false;
          if (block.timeout) {
            _this.resetToFirstImage(block);
            clearTimeout(block.timeout);
          }
        });
      }
    });
  }

  (0, _createClass3.default)(DynamicFeatureBlocks, [{
    key: 'createTimeout',
    value: function createTimeout(block) {
      return new Promise(function (resolve, reject) {
        block.timeout = setTimeout(function () {
          resolve();
        }, 1500);
      });
    }
  }, {
    key: 'showNextImage',
    value: function showNextImage(block) {
      var _this2 = this;

      if (!block.imageSize || !block.flag) {
        return;
      }

      var nextImageIndex = (parseInt(block.blockEl.dataset.imageIndex) + 1 || 1) % block.images.length;
      var newImage = document.createElement('img');
      newImage.src = Shopify.getSizedImageUrl(block.images[nextImageIndex], block.imageSize);
      newImage.classList.add('feature-block-hover-img');
      newImage.setAttribute('data-rimg', 'loaded');
      var trend = this.events.register(newImage, 'animationend', function () {
        _this2.events.unregister(trend);
        if (newImage.previousElementSibling.matches('.feature-block-hover-img')) {
          newImage.previousElementSibling.remove();
        }
      });

      block.blockEl.firstElementChild.insertBefore(newImage, block.blockEl.querySelector('[data-rimg-canvas]'));
      block.blockEl.dataset.imageIndex = nextImageIndex;

      var promises = [];
      promises.push(this.createTimeout(block), preloadImage(Shopify.getSizedImageUrl(block.images[(parseInt(block.blockEl.dataset.imageIndex) + 1 || 1) % block.images.length], block.imageSize)));

      Promise.all(promises).then(function () {
        _this2.showNextImage(block);
      });
    }
  }, {
    key: 'resetToFirstImage',
    value: function resetToFirstImage(block) {
      var _this3 = this;

      block.blockEl.querySelectorAll('.feature-block-hover-img').forEach(function (img) {
        var trend = _this3.events.register(img, 'animationend', function () {
          _this3.events.unregister(trend);
          img.remove();
        });
        block.blockEl.dataset.imageIndex = 0;
        img.classList.add('fade-out');
      });
    }
  }, {
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.events.unregisterAll();
    }
  }]);
  return DynamicFeatureBlocks;
}();

exports.default = DynamicFeatureBlocks;